import React from "react";
import { Button } from "@chakra-ui/react";

export type ActionButtonProps = {
  variant: "primary" | "secondary";
  label: string;
  onClick: () => void;
  ariaLabel?: string;
  iconLeft?: React.ReactNode;
};

const ActionButton: React.FC<ActionButtonProps> = ({ variant, label, onClick, ariaLabel, iconLeft }) => {
  const isPrimary = variant === "primary";
  return (
    <Button
      onClick={onClick}
      aria-label={ariaLabel || label}
      leftIcon={iconLeft as any}
      borderRadius="14px"
      fontSize={{ base: "15px", md: "16px" }}
      fontWeight="800"
      px={{ base: 6, md: 8 }}
      h={{ base: "50px", md: "54px" }}
      w={{ base: "100%", md: isPrimary ? "260px" : "220px" }}
      bg={isPrimary ? "#4A2C2A" : "white"}
      color={isPrimary ? "white" : "#4A2C2A"}
      borderWidth={isPrimary ? "0px" : "1px"}
      borderColor={isPrimary ? "transparent" : "#D9CFCF"}
      _hover={{ bg: isPrimary ? "#3d2422" : "#FAF7F7" }}
      boxShadow={isPrimary ? "0 10px 22px rgba(74, 44, 42, 0.28)" : "none"}
      _focusVisible={{ boxShadow: "0 0 0 2px rgba(74,44,42,0.35)" }}
    >
      {label}
    </Button>
  );
};

export default ActionButton;
